/**
 * Login Widget — Entry Point
 * Exposes window.LoginWidget for use on login.html and the session-expired modal.
 */

import { initPage, showModal } from './login-widget';
import type { LoginWidgetApi } from './types';

declare global {
  interface Window {
    LoginWidget: LoginWidgetApi;
  }
}

window.LoginWidget = {
  initPage,
  showModal,
};
